import React from 'react';

// Connect
import { useAppDispatch } from 'lib/hooks/useDispatch';

// Lib
import { decodeHtmlEntity, getImgUrl } from 'lib/helpers';

// Components
import Img from 'components/Img';
import ListSupplierLogo from 'components/ListSupplierLogo/ListSupplierLogo';
import { ICartCompoundsDescriptor } from 'components/Carts/CartProduct/CartCompounds';

// Actions
import { openModal } from 'reducers/modal';
import { Supplier } from 'pages/MoleculeProduct/reducer';

// Type
type TMap = {
	label?: string;
	isArray?: boolean;
	className?: string;
	value?: string | Supplier[];
};
type TPrice = {
	mg?: number,
	priceEur?: number,
	priceUsd?: number,
	available?: boolean,
}

// Interface
interface IDescription {
	id?: string,
	cas?: string,
	name?: string,
	dbId?: string,
	purity?: number | null,
	img?: string,
	smiles?: string,
	mdlNumber?: string,
	prices?: TPrice[],
	supIds?: Supplier[],
	synonyms?: string,
	cxSmiles?: string,
	iupacName?: string,
	description?: string,
	onStock?: boolean | null,
	descriptor?: ICartCompoundsDescriptor
}

export const Description: React.FC<IDescription> = (props) => {
	const dispatch = useAppDispatch();

	const {
		id,
		cas,
		supIds,
		purity,
		description
	} = props;

	const src: string = id ? getImgUrl({
		id: id,
		w: 298.66 * 3,
		h: 146.13 * 3
	}) : '';

	const handlerClickBanner = () => {
		const urlBanner = id ? getImgUrl({
			id: id,
			w: 500,
			h: 350
		}) : '';
		dispatch(openModal({
			type: 'bunner',
			url: urlBanner
		}));
	};

	const configDescription: TMap[] = [
		{
			label: 'ID',
			isArray: true,
			value: supIds?.length ? supIds : '-',
			className: 'molecule-product__text--active'
		},
		{
			label: 'CAS',
			isArray: false,
			value: cas ? cas : '-'
		},
		{
			value: purity ? `${purity}%` : '',
			label: 'Purity',
			isArray: false
		},
		{
			label: '',
			isArray: false,
			value: description ? description : ''
		}
	];

	return (
		<div className="molecule-product__description">
			<div className="flex flex-ai-start flex-direction-column-mobile molecule-product__main-img-wrapper">
				<div onClick={handlerClickBanner}>
					<Img
						isPreloader
						innerSrc={src}
						alt="Molecule product"
						classNameWrapper="molecule-product__main-img"
						classNameSvgError="molecule-product__main-img flex flex-ai-center flex-jc-center"
					/>
				</div>

				<div className="display-none-mobile">
					{configDescription?.map((item: TMap, i: number) => {
						return (
							<div
								key={`${item.label}__${i}`}
								className={`molecule-product__text flex flex-ai-center flex-direction-column-desktop ${item.className ? item.className : ''}`}
							>
								{!!item.label && <p className="molecule-product__text-span">{item.label}</p>}

								<div className="molecule-product__text-p">
									{!item.isArray && typeof item.value === 'string' && (
										<p
											className="molecule-product__text-p"
											dangerouslySetInnerHTML={{ __html: decodeHtmlEntity(item.value || '') }}
										/>
									)}

									{item.isArray && Array.isArray(item.value) && <ListSupplierLogo
										data={item.value}
										classNameWrapperLogo="mr5"
										classNameText="molecule-product__text-p"
									/>}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default Description;